import {createFileRoute} from '@tanstack/react-router';
import ClubDashboard from '../../../../clubs/dashboard/ClubDashboard';

// Communities share the dashboard shell — same tiles, same contract; only the panel list below
// the band will differ per club type in a later step.
export const Route = createFileRoute('/_app/communities/$community_uid/dashboard')({
    component: () => {
        const {community_uid} = Route.useParams();
        return <ClubDashboard clubUid={community_uid} />;
    },
});
